import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ModalModule } from 'ngx-bootstrap';
import { RoutingModule } from './routing/routing.module';
import { AppComponent } from './app.component';

import { NgSelectModule, NG_SELECT_DEFAULT_CONFIG } from '@ng-select/ng-select';

import { BrainStormComponent } from './brain-storm/brain-storm.component';
import { BSDayViewComponent } from './brain-storm/bs-day-view/bs-day-view.component';

import { BSMonthViewComponent } from './brain-storm/bs-month-view/bs-month-view.component';
import { BSCalendarComponent } from './brain-storm/bs-month-view/bs-calendar/bs-calendar.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { GenService } from './shared/gen-ser.service';
import { DataService } from './shared/dataservice.service';
import { DailyActComponent } from './daily-act/daily-act.component';
import { ProdHighComponent } from './daily-act/prod-high/prod-high.component';
import { DateScrollerComponent } from './common/date-scroller/date-scroller.component';
import { TokenFieldComponent } from './common/token-field/token-field.component';
import { MatShortComponent } from './daily-act/mat-short/mat-short.component';
import { DlvyPlanComponent } from './daily-act/dlvy-plan/dlvy-plan.component';
import { CustInspPlanComponent } from './daily-act/cust-insp-plan/cust-insp-plan.component';
import { GrnSticPlanComponent } from './daily-act/grn-stic-plan/grn-stic-plan.component';
import { InprQualIssuComponent } from './daily-act/inpr-qual-issu/inpr-qual-issu.component';
import { CcrpStatMonComponent } from './daily-act/ccrp-stat-mon/ccrp-stat-mon.component';
import { ProdStatMonComponent } from './daily-act/prod-stat-mon/prod-stat-mon.component';
import { ManPowAllocComponent } from './daily-act/man-pow-alloc/man-pow-alloc.component';
import { PolStkRvwComponent } from './daily-act/pol-stk-rvw/pol-stk-rvw.component';
import { GembaCardComponent } from './gemba-card/gemba-card.component';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SafetyAppComponent } from './gemba-card/safety-app/safety-app.component';
import { TestingAppComponent } from './gemba-card/testing-app/testing-app.component';
import { MaterialAppComponent } from './gemba-card/material-app/material-app.component';
import { QualityAppComponent } from './gemba-card/quality-app/quality-app.component';
import { GenCalendarComponent } from './common/gen-calendar/gen-calendar.component';
import { NwcmTreeComponent } from './nwcm-tree/nwcm-tree.component';
import { SummaryPageComponent } from './summary-page/summary-page.component';
import { CcrpDayViewComponent } from './daily-act/ccrp-stat-mon/ccrp-day-view/ccrp-day-view.component';
import { InprQualDayViewComponent } from './daily-act/inpr-qual-issu/inpr-qual-day-view/inpr-qual-day-view.component';
import { CcrpComponent } from './summary-page/ccrp/ccrp.component';
import { DailyProdComponent } from './summary-page/daily-prod/daily-prod.component';
import { InprocessQualComponent } from './summary-page/inprocess-qual/inprocess-qual.component';
import { PrdtnStatusComponent } from './summary-page/prdtn-status/prdtn-status.component';
import { PoleStkRevwComponent } from './summary-page/pole-stk-revw/pole-stk-revw.component';
import { ManPwrAllctnComponent } from './summary-page/man-pwr-allctn/man-pwr-allctn.component';
import { MtrlShrtgeComponent } from './summary-page/mtrl-shrtge/mtrl-shrtge.component';
import { DailyDlvryPlnComponent } from './summary-page/daily-dlvry-pln/daily-dlvry-pln.component';
import { CustInspPlnComponent } from './summary-page/cust-insp-pln/cust-insp-pln.component';
import { GreenStkrPlanComponent } from './summary-page/green-stkr-plan/green-stkr-plan.component';
import { NwcmTreeCompactComponent } from './nwcm-tree/nwcm-tree-compact/nwcm-tree-compact.component';
import { HtmlConvertPipe } from './shared/html-convert.pipe';
import { FinishedGoodsComponent } from './daily-act/finished-goods/finished-goods.component';
import { FinishedGoodsDayViewComponent } from './daily-act/finished-goods/finished-goods-day-view/finished-goods-day-view.component';
import { MatShortExtrnlComponent } from './daily-act/mat-short-extrnl/mat-short-extrnl.component';
import { MaterialAppNewComponent } from './gemba-card/material-app-new/material-app-new.component';
import { QualityAppNewComponent } from './gemba-card/quality-app-new/quality-app-new.component';
import { ErrorPopupComponent } from './common/error-popup/error-popup.component';
//import { InprQualIssuChildComponent } from './daily-act/inpr-qual-issu/inpr-qual-issu-child/inpr-qual-issu-child.component';



@NgModule({
  declarations: [
    AppComponent,
    BrainStormComponent,
    BSDayViewComponent,
    BSMonthViewComponent,
    BSCalendarComponent,
    NavMenuComponent,
    DailyActComponent,
    ProdHighComponent,
    DateScrollerComponent,
    TokenFieldComponent,
    MatShortComponent,
    DlvyPlanComponent,
    CustInspPlanComponent,
    GrnSticPlanComponent,
    InprQualIssuComponent,
    CcrpStatMonComponent,
    ProdStatMonComponent,
    ManPowAllocComponent,
    PolStkRvwComponent,
    GembaCardComponent,
    SafetyAppComponent,
    TestingAppComponent,
    MaterialAppComponent,
    QualityAppComponent,
    GenCalendarComponent,
    SummaryPageComponent,
    CcrpDayViewComponent,
    InprQualDayViewComponent,
    CcrpComponent,
    DailyProdComponent,
    InprocessQualComponent,
    PrdtnStatusComponent,
    PoleStkRevwComponent,
    ManPwrAllctnComponent,
    MtrlShrtgeComponent,
    DailyDlvryPlnComponent,
    CustInspPlnComponent,
    GreenStkrPlanComponent,
    NwcmTreeComponent,
    SummaryPageComponent,
    NwcmTreeCompactComponent,
    HtmlConvertPipe,
    FinishedGoodsComponent,
    FinishedGoodsDayViewComponent,
    MatShortExtrnlComponent,
    MaterialAppNewComponent,
    QualityAppNewComponent,
    //InprQualIssuChildComponent,
    ErrorPopupComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RoutingModule,
    ModalModule.forRoot(),
    NgSelectModule,
    // DatepickerModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    BrowserAnimationsModule
  ],
  providers: [
    GenService, 
    DataService,
      {
        provide: NG_SELECT_DEFAULT_CONFIG,
        useValue: {
            notFoundText: 'Not Found'
        }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
